// Interiors & architecture costume v1 — design studios, architects, contractors.
// Engine stage KEYS never change; only the labels do.

export const INTERIORS_COSTUME = {
  costumeId: "interiors_v1",

  stages: [
    { key: "new", label: "New" },
    { key: "spoke", label: "Spoke to them" },
    { key: "visit_scheduled", label: "Site visit scheduled" },
    { key: "visited", label: "Site visited" },
    { key: "sent_price", label: "Sent proposal" },
    { key: "signed_up", label: "Project signed" },
    { key: "lost", label: "Lost" },
  ],

  stageColors: {
    new: "bg-amber-100 text-amber-800 border-amber-200",
    spoke: "bg-orange-100 text-orange-800 border-orange-200",
    visit_scheduled: "bg-yellow-100 text-yellow-800 border-yellow-200",
    visited: "bg-emerald-100 text-emerald-800 border-emerald-200",
    sent_price: "bg-rose-100 text-rose-800 border-rose-200",
    signed_up: "bg-green-100 text-green-800 border-green-200",
    lost: "bg-zinc-200 text-zinc-700 border-zinc-300",
  },

  defaultSources: [
    "Walk-in",
    "Phone call",
    "Website",
    "Instagram",
    "Referral",
    "Exhibition",
    "Others",
  ],

  lostReasons: [
    "Budget too high",
    "Timeline didn't work",
    "Chose another designer",
    "Project postponed",
    "Just exploring",
    "Stopped responding",
    "Other",
  ],

  enquiryTypes: [
    "Full home interiors",
    "Modular kitchen",
    "Office / Commercial interiors",
    "Renovation",
    "Architecture / Design only",
    "Single room makeover",
  ],

  waTemplates: [
    { name: "First contact", body: "Hi {{name}}, this is {{me}} from {{company}}. Thanks for reaching out — would love to hear about your space and what you have in mind." },
    { name: "Site visit invite", body: "Hi {{name}}, shall we fix a site visit? Seeing the space helps us give you a much better plan and estimate." },
    { name: "Proposal share", body: "Hi {{name}}, sharing the proposal as discussed: {{quote}}. Happy to walk you through it whenever you're free." },
    { name: "Soft follow-up", body: "Hi {{name}}, just checking in — any thoughts on the proposal?" },
    { name: "Polite drop", body: "Hi {{name}}, hope all's well. Closing this for now; whenever your project picks up again, ping me." },
  ],

  companyInfo: { name: "", me: "", address: "" },

  vocab: {
    unit: "room",
    units: "rooms",
    location: "site",
    locations: "sites",
    customer: "client",
  },

  copy: {
    appName: "Jigyasa",
    sectionTrend: "Enquiries vs signed projects — last 6 months",
    sectionAttention: "Needs your attention",
    attentionAllClear: "All caught up — nothing is waiting on you.",
    attentionWaitingQuote: "waiting after proposal",
    remarksTitle: "Remarks & history",
    remarkPlaceholder: "e.g. Sharing reference photos — follow up Friday",
    addRemarkButton: "Add",
    remarksEmpty: "No remarks yet — add one after each call so the story stays in one place.",
    settingsSourcesTitle: "Manage enquiry sources",
    settingsSourcesNote: "Each organisation sets up its own list of where enquiries come from. Removing a source never changes past enquiries — it only affects new ones.",
    pastEnquiryBannerLabel: "Returning lead",
    pastEnquiryBannerNote: "We've spoken before — don't start cold.",
    footprintBannerLabel: "Already with us",
    footprintInlineDismiss: "This is someone new — clear and start fresh",
  },

  buttonsOn: {
    liveStock: false,
    upcomingStock: false,
    customerFootprint: false,
    pastEnquiries: true,
    pricingAndOffers: false,
    activityHistory: false,
    renewalPipeline: false,
    locationCatalog: false,
    satisfaction: false,
    availability: false,
    compliance: false,
    communications: false,
  },
};
